export const GCR = {
    page: 'grow-category-restriction-page',

    // Filter bar
    filterBar: 'grow-category-restriction__filter-bar',

    // Panels
    panelsWrapper: 'grow-category-restriction__panels-wrapper',
    hierarchyPanel: 'grow-category-restriction__hierarchy-panel',
    restrictionsPanel: 'grow-category-restriction__restrictions-panel',

    // Inputs
    input: 'grow-category-restriction-input',
    inputButton: 'grow-category-restriction-input--button',
    inputTextfield: 'grow-category-restriction-input--textfield',
    inputSelectCountry: 'grow-category-restriction-input--select-country',
    inputSelectZone: 'grow-category-restriction-input--select-zone',

    // Buttons
    btnClear: 'grow-category-restriction-btn--clear',
    btnFilter: 'grow-category-restriction-btn--filter',
    btnRestrict: 'grow-category-restriction-btn--restrict',
} as const;

export const gcrCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
